<template>
  <v-app-bar
    app
    clipped-left
    fixed
    flat
    class="transparent"
  >
    <v-btn icon to="/" v-if="title">
      <v-icon>mdi-keyboard-backspace</v-icon>
    </v-btn>
    <v-toolbar-title>{{ $t(title) }}</v-toolbar-title>
    <v-spacer></v-spacer>
    
    <v-menu
      left
      bottom
    >
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          {{ lang }}
        </v-btn>
      </template>
      <v-list>
        <v-list-item @click="setLang(lng.key)" v-for="(lng, i) in langs" :key="i">
          <v-list-item-action><span class="text-uppercase">{{ lng.key }}</span></v-list-item-action>
          <v-list-item-content>{{ lng.name }}</v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
    
  </v-app-bar>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data: () => ({
    drawer: null,
    langs: [
      { key: 'pl', name: 'Polski' },
      { key: 'en', name: 'English' }
    ],

  }),
  computed: {
    hidemenu() {
      return this.$route.meta.hidemenu;
    },
    lang() {
      return this.$i18n.locale
    }
  },
  methods: {
    ...mapActions([
      'setLang',
    ]),
  },
  props: ['title']
}
</script>

<style>

</style>